export * from './generated/types.js';

export const LIST_AI_CHATS = /* GraphQL */ `
  query ListAiChats($limit: Int, $cursor: String) {
    listAiChats(limit: $limit, cursor: $cursor) {
      items {
        id
        title
        lastMessagePreview
        createdAt
        updatedAt
      }
      cursor
    }
  }
`;

export const GET_AI_CHAT = /* GraphQL */ `
  query GetAiChat($chatId: ID!, $messageLimit: Int, $messageCursor: String) {
    getAiChat(chatId: $chatId, messageLimit: $messageLimit, messageCursor: $messageCursor) {
      id
      title
      lastMessagePreview
      createdAt
      updatedAt
      messages {
        id
        chatId
        role
        content
        status
        clientRequestId
        createdAt
        completedAt
        modelId
        stopReason
        errorCode
        usage {
          inputTokens
          outputTokens
          totalTokens
        }
      }
      nextMessageCursor
    }
  }
`;

export const CREATE_AI_CHAT = /* GraphQL */ `
  mutation CreateAiChat($chatId: ID!) {
    createAiChat(chatId: $chatId) {
      id
      title
      lastMessagePreview
      createdAt
      updatedAt
    }
  }
`;

export const SEND_AI_CHAT_MESSAGE = /* GraphQL */ `
  mutation SendAiChatMessage($input: SendAiChatMessageInput!) {
    sendAiChatMessage(input: $input) {
      chat {
        id
        title
        lastMessagePreview
        createdAt
        updatedAt
      }
      userMessage {
        id
        chatId
        role
        content
        status
        clientRequestId
        createdAt
        completedAt
        errorCode
      }
      assistantMessage {
        id
        chatId
        role
        content
        status
        clientRequestId
        createdAt
        completedAt
        modelId
        stopReason
        errorCode
        usage {
          inputTokens
          outputTokens
          totalTokens
        }
      }
    }
  }
`;

export const DELETE_AI_CHAT = /* GraphQL */ `
  mutation DeleteAiChat($chatId: ID!) {
    deleteAiChat(chatId: $chatId) {
      chatId
      deleted
    }
  }
`;

const AIRCRAFT_TYPE_FIELDS = /* GraphQL */ `
  id
  aircraftManufacturerId
  icaoManufacturerCode
  aircraftMarketingCategory
  aircraftType
  aircraftTypeDescription
  icaoAircraftDesc
  icaoDescription
  wakeTurbulenceCategory
  typeDesignatorCode
  modelNumber
  modelName
  modelVersion
  production
  productionStartYear
  productionEndYear
  firstFlightYear
  engineType
  engineCount
  engineManufacturerCode
  engineDescription
  ratedTakeoffThrustKg
  ratedTakeoffThrustLbs
  aircraftCategory
  rangeKm
  rangeNm
  maxRangeKm
  maxRangeNm
  highSpeedCruiseRangeKm
  highSpeedCruiseRangeNm
  cruiseSpeedKmh
  cruiseSpeedMph
  longRangeCruiseSpeedKmh
  longRangeCruiseSpeedMph
  longRangeCruiseSpeedMach
  highSpeedCruiseSpeedKmh
  highSpeedCruiseSpeedMph
  highSpeedCruiseSpeedMach
  maxOperatingMachNumber
  takeOffDistanceM
  takeOffDistanceFt
  landingDistanceM
  landingDistanceFt
  climbRateMps
  climbRateFps
  descentRateMps
  descentRateFps
  initialCruiseAltitudeM
  initialCruiseAltitudeFt
  maxCruiseAltitudeM
  maxCruiseAltitudeFt
  maxOperatingAltitudeM
  maxOperatingAltitudeFt
  maxTakeoffWeightKg
  maxTakeoffWeightLbs
  maxLandingWeightKg
  maxLandingWeightLbs
  maxZeroFuelWeightKg
  maxZeroFuelWeightLbs
  basicOperatingWeightKg
  basicOperatingWeightLbs
  maxPayloadKg
  maxPayloadLbs
  maxPayloadFullFuelKg
  maxPayloadFullFuelLbs
  maxFuelCapacityKg
  maxFuelCapacityLbs
  avionics
  aircraftLengthM
  aircraftLengthFt
  aircraftHeightM
  aircraftHeightFt
  wingspanM
  wingspanFt
  cabinHeightM
  cabinHeightFt
  cabinWidthM
  cabinWidthFt
  cabinLengthM
  cabinLengthFt
  cabinVolumeM3
  cabinVolumeCuft
  cabinLivingAreas
  seatingCapacityMax
  seatingCapacityTypical
  isBeddingConfigurationAvailable
  beddingConfigurationDescription
  isGalleyAvailable
  galleyDescription
  isLavatoryAvailable
  lavatoryDescription
  minCockpitCrew
  baggageVolumeM3
  baggageVolumeCuft
  baggagePieces
  images
  videos
  slug
  metaTitle
  metaDescription
  metaKeywords
  priceRentalHourEUR
  priceRentalHourUSD
  priceNewEUR
  priceNewUSD
  priceUsedEUR
  priceUsedUSD
  isPublished
  publishedAt
  comments
  version
  createdAt
  updatedAt
  createdBy
  updatedBy
  deletedAt
`;

export const LIST_AIRCRAFT_TYPES = /* GraphQL */ `
  query ListAircraftTypes($limit: Int, $nextToken: String, $includeUnpublished: Boolean) {
    listAircraftTypes(
      limit: $limit
      nextToken: $nextToken
      includeUnpublished: $includeUnpublished
    ) {
      items {
        ${AIRCRAFT_TYPE_FIELDS}
      }
      nextToken
    }
  }
`;

export const GET_AIRCRAFT_TYPE = /* GraphQL */ `
  query GetAircraftType($id: ID!) {
    getAircraftType(id: $id) {
      ${AIRCRAFT_TYPE_FIELDS}
    }
  }
`;

export const CREATE_AIRCRAFT_TYPE = /* GraphQL */ `
  mutation CreateAircraftType($input: AircraftTypeInput!) {
    createAircraftType(input: $input) {
      ${AIRCRAFT_TYPE_FIELDS}
    }
  }
`;

export const UPDATE_AIRCRAFT_TYPE = /* GraphQL */ `
  mutation UpdateAircraftType($id: ID!, $input: AircraftTypeInput!) {
    updateAircraftType(id: $id, input: $input) {
      ${AIRCRAFT_TYPE_FIELDS}
    }
  }
`;

export const DELETE_AIRCRAFT_TYPE = /* GraphQL */ `
  mutation DeleteAircraftType($id: ID!) {
    deleteAircraftType(id: $id) {
      success
      id
    }
  }
`;

export const GET_WORKSPACE_STAT_SNAPSHOT_V1 = /* GraphQL */ `
  query GetWorkspaceStatSnapshotV1(
    $organisationId: String!
    $workspaceId: String!
    $domain: WorkspaceStatDomain!
    $segment: String!
  ) {
    getWorkspaceStatSnapshotV1(
      organisationId: $organisationId
      workspaceId: $workspaceId
      domain: $domain
      segment: $segment
    ) {
      id
      organisationId
      workspaceId
      domain
      segment
      customersCount
      suppliersCount
      unclassifiedCount
      uniqueExternalActiveCount
      schemaVersion
      revision
      updatedAt
    }
  }
`;

export const GET_COUNTERPARTY_V1 = /* GraphQL */ `
  query GetCounterpartyV1($workspaceId: String!, $id: String!) {
    getCounterpartyV1(workspaceId: $workspaceId, id: $id) {
      id
      publicId
      workspaceId
      organisationId
      isWorkspaceInternal
      kind
      displayName
      partyTypes
      isActive
      primaryTaxId
      primaryRegistrationId
      primaryCountryCode
      primaryAddressLine1
      primaryAddressLine2
      primaryPostalCode
      primaryCity
      primaryEmail
      primaryPhone
      primaryWebsite
      legalEntityProfile
      humanProfile
      identifiers {
        id
        identifierType
        identifierValue
        identifierValueNormalized
        issuingCountryCode
        issuer
        isPrimary
        lifecycleStatus
        source {
          kind
          ref
        }
        privateRemarks
        validFrom
        validTo
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
      contacts {
        id
        contactType
        contactProvider
        contactValue
        label
        isPrimary
        isVerified
        privateRemarks
        source {
          kind
          ref
        }
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
      locations {
        id
        locationType
        countryCode
        postalCode
        addressLine1
        addressLine2
        city
        latitude
        longitude
        isPrimary
        privateRemarks
        source {
          kind
          ref
        }
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
      externalSources {
        id
        provider
        providerRecordKind
        sourceScopeKey
        sourceScope
        sourceRecordId
        displayNameSnapshot
        fingerprint
        createdAt
        updatedAt
        sourcePrimaryKey {
          name
          value
          normalizedValue
        }
        sourceUserKeys {
          name
          value
          normalizedValue
          label
          uniquenessScope
          isDisplayKey
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const LIST_COUNTERPARTIES_V1 = /* GraphQL */ `
  query ListCounterpartiesV1(
    $organisationId: String!
    $workspaceId: String!
    $isWorkspaceInternal: Boolean
    $isActive: Boolean
    $kind: CounterpartyKind
    $catalogPartyType: CounterpartyCatalogPartyType
    $limit: Int
    $nextToken: String
  ) {
    listCounterpartiesV1(
      organisationId: $organisationId
      workspaceId: $workspaceId
      isWorkspaceInternal: $isWorkspaceInternal
      isActive: $isActive
      kind: $kind
      catalogPartyType: $catalogPartyType
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        publicId
        workspaceId
        organisationId
        isWorkspaceInternal
        kind
        displayName
        partyTypes
        isActive
        primaryTaxId
        primaryRegistrationId
        primaryCountryCode
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const CREATE_COUNTERPARTY_V1 = /* GraphQL */ `
  mutation CreateCounterpartyV1(
    $workspaceId: String!
    $id: String
    $publicId: String
    $kind: CounterpartyKind
    $displayName: String!
    $organisationId: String
    $isWorkspaceInternal: Boolean
    $partyTypes: [String]
    $exportToSoftone: Boolean
    $exportViaCounterpartyId: String
    $vatType: String
    $roles: [String]
    $isActive: Boolean
    $identifiers: [CounterpartyIdentifierInput]
    $legalEntityProfile: LegalEntityProfileInput
    $humanProfile: AWSJSON
  ) {
    createCounterpartyV1(
      workspaceId: $workspaceId
      id: $id
      publicId: $publicId
      kind: $kind
      displayName: $displayName
      organisationId: $organisationId
      isWorkspaceInternal: $isWorkspaceInternal
      partyTypes: $partyTypes
      exportToSoftone: $exportToSoftone
      exportViaCounterpartyId: $exportViaCounterpartyId
      vatType: $vatType
      roles: $roles
      isActive: $isActive
      identifiers: $identifiers
      legalEntityProfile: $legalEntityProfile
      humanProfile: $humanProfile
    ) {
      id
      publicId
      workspaceId
      organisationId
      isWorkspaceInternal
      kind
      displayName
      partyTypes
      isActive
      primaryTaxId
      primaryRegistrationId
      primaryCountryCode
      createdAt
      updatedAt
    }
  }
`;

export const LIST_COUNTERPARTY_SOURCE_RECORDS_BY_TENANT = /* GraphQL */ `
  query ListCounterpartySourceRecordsByTenant(
    $tenantId: String!
    $provider: String
    $sourcePrimaryKeyPrefix: String
    $canonicalAssignmentState: CounterpartyCanonicalAssignmentState
    $limit: Int
    $nextToken: String
  ) {
    listCounterpartySourceRecordsByTenant(
      tenantId: $tenantId
      provider: $provider
      sourcePrimaryKeyPrefix: $sourcePrimaryKeyPrefix
      canonicalAssignmentState: $canonicalAssignmentState
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        sourceRecordId
        tenantId
        provider
        sourcePrimaryKeyValue
        sourceState
        lastSyncedAt
        normalizedDisplayName
        normalizedTaxId
        canonicalAssignmentState
        instanceSerialNumber
        sourcePrimaryKey {
          name
          value
          normalizedValue
        }
        sourceUserKeys {
          name
          value
          normalizedValue
          label
          uniquenessScope
          isDisplayKey
        }
      }
      nextToken
    }
  }
`;

export const RESOLVE_PRINCIPAL_SESSION = /* GraphQL */ `
  query ResolvePrincipalSession {
    resolvePrincipalSession {
      principalSub
      needsOnboarding
      activeWorkspaceId
      activeOrgId
      organisations {
        id
        name
        role
      }
      workspaces {
        id
        orgId
        name
        role
      }
    }
  }
`;

export const COMPLETE_ONBOARDING = /* GraphQL */ `
  mutation CompleteOnboarding($organisationName: String!, $workspaceName: String) {
    completeOnboarding(organisationName: $organisationName, workspaceName: $workspaceName) {
      principalSub
      needsOnboarding
      activeWorkspaceId
      activeOrgId
      organisations {
        id
        name
        role
      }
      workspaces {
        id
        orgId
        name
        role
      }
    }
  }
`;

export const GET_ACTIVE_ORGANISATION = /* GraphQL */ `
  query GetActiveOrganisation {
    getActiveOrganisation {
      id
      displayName
      ownerPrincipalSub
      status
      contact {
        fullName
        phone
        addressLine1
        addressLine2
        addressLine3
        city
        state
        zipCode
        country
      }
    }
  }
`;

export const UPDATE_ORGANISATION_CONTACT = /* GraphQL */ `
  mutation UpdateOrganisationContact($contact: UpdateOrganisationContactInput!) {
    updateOrganisationContact(contact: $contact) {
      id
      displayName
      ownerPrincipalSub
      status
      contact {
        fullName
        phone
        addressLine1
        addressLine2
        addressLine3
        city
        state
        zipCode
        country
      }
    }
  }
`;

export const LIST_ORGANISATION_WORKSPACES = /* GraphQL */ `
  query ListOrganisationWorkspaces {
    listOrganisationWorkspaces {
      id
      displayName
      orgId
      parentWorkspaceId
      status
      role
    }
  }
`;

const ORGANISATION_MEMBER_FIELDS = /* GraphQL */ `
  principalSub
  organisationId
  email
  givenName
  familyName
  locale
  organisationRole
  workspaces { workspaceId workspaceName role }
  status
  deliveryStatus
  identityProvisioningOrigin
  invitedAt
  inviteExpiresAt
  invitedBy
  updatedAt
`;

export const LIST_ORGANISATION_MEMBERS = /* GraphQL */ `
  query ListOrganisationMembers($limit: Int, $nextToken: String) {
    listOrganisationMembers(limit: $limit, nextToken: $nextToken) {
      items { ${ORGANISATION_MEMBER_FIELDS} }
      nextToken
    }
  }
`;

export const INVITE_ORGANISATION_MEMBER = /* GraphQL */ `
  mutation InviteOrganisationMember($input: InviteOrganisationMemberInput!) {
    inviteOrganisationMember(input: $input) { ${ORGANISATION_MEMBER_FIELDS} }
  }
`;

export const RESEND_ORGANISATION_MEMBER_INVITE = /* GraphQL */ `
  mutation ResendOrganisationMemberInvite($principalSub: String!) {
    resendOrganisationMemberInvite(principalSub: $principalSub) {
      ${ORGANISATION_MEMBER_FIELDS}
    }
  }
`;

export const CANCEL_ORGANISATION_MEMBER_INVITE = /* GraphQL */ `
  mutation CancelOrganisationMemberInvite($principalSub: String!) {
    cancelOrganisationMemberInvite(principalSub: $principalSub) {
      ${ORGANISATION_MEMBER_FIELDS}
    }
  }
`;

const USER_NOTIFICATION_SETTINGS_FIELDS = /* GraphQL */ `
  principalSub
  version
  inApp {
    enabled
    autoSubscribe
  }
  createdAt
  updatedAt
  createdBy
  updatedBy
`;

export const GET_USER_NOTIFICATION_SETTINGS = /* GraphQL */ `
  query GetUserNotificationSettings {
    getUserNotificationSettings {
      ${USER_NOTIFICATION_SETTINGS_FIELDS}
    }
  }
`;

export const UPDATE_USER_NOTIFICATION_SETTINGS = /* GraphQL */ `
  mutation UpdateUserNotificationSettings($input: UpdateUserNotificationSettingsInput!) {
    updateUserNotificationSettings(input: $input) {
      ${USER_NOTIFICATION_SETTINGS_FIELDS}
    }
  }
`;

const PERSONAL_PROFILE_FIELDS = /* GraphQL */ `
  principalSub
  displayName
  givenName
  familyName
  phone
  avatarUrl
  locale
  version
  updatedAt
`;

export const GET_MY_PROFILE = /* GraphQL */ `
  query GetMyProfile {
    getMyProfile {
      ${PERSONAL_PROFILE_FIELDS}
    }
  }
`;

export const UPDATE_MY_PROFILE = /* GraphQL */ `
  mutation UpdateMyProfile($input: UpdateMyProfileInput!) {
    updateMyProfile(input: $input) {
      ${PERSONAL_PROFILE_FIELDS}
    }
  }
`;

export const CREATE_MY_AVATAR_UPLOAD = /* GraphQL */ `
  mutation CreateMyAvatarUpload($contentType: String!, $contentLength: Int!) {
    createMyAvatarUpload(contentType: $contentType, contentLength: $contentLength) {
      uploadId
      key
      postUrl
      fields {
        name
        value
      }
    }
  }
`;

export const SET_MY_AVATAR = /* GraphQL */ `
  mutation SetMyAvatar($key: String!, $expectedVersion: Int!) {
    setMyAvatar(key: $key, expectedVersion: $expectedVersion) {
      ${PERSONAL_PROFILE_FIELDS}
    }
  }
`;

export const REMOVE_MY_AVATAR = /* GraphQL */ `
  mutation RemoveMyAvatar($expectedVersion: Int!) {
    removeMyAvatar(expectedVersion: $expectedVersion) {
      ${PERSONAL_PROFILE_FIELDS}
    }
  }
`;

export const GET_COUNTERPARTY_SYNC_SCHEDULE = /* GraphQL */ `
  query GetCounterpartySyncSchedule(
    $provider: String!
    $tenantId: String
    $organisationId: String
    $workspaceId: String
    $counterpartyId: String
  ) {
    getCounterpartySyncSchedule(
      provider: $provider
      tenantId: $tenantId
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
    ) {
      schedule {
        provider
        scheduleName
        groupName
        state
        scheduleExpression
        scheduleExpressionTimezone
        targetArn
        tenantId
        organisationId
        workspaceId
        counterpartyId
        lastUpdatedAt
      }
    }
  }
`;

export const UPSERT_COUNTERPARTY_SYNC_SCHEDULE = /* GraphQL */ `
  mutation UpsertCounterpartySyncSchedule(
    $provider: String!
    $scheduleExpression: String!
    $scheduleExpressionTimezone: String
    $enabled: Boolean
    $tenantId: String
    $organisationId: String
    $workspaceId: String
    $counterpartyId: String
  ) {
    upsertCounterpartySyncSchedule(
      provider: $provider
      scheduleExpression: $scheduleExpression
      scheduleExpressionTimezone: $scheduleExpressionTimezone
      enabled: $enabled
      tenantId: $tenantId
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
    ) {
      schedule {
        provider
        scheduleName
        groupName
        state
        scheduleExpression
        scheduleExpressionTimezone
      }
    }
  }
`;

export const SET_COUNTERPARTY_SYNC_SCHEDULE_ENABLED = /* GraphQL */ `
  mutation SetCounterpartySyncScheduleEnabled(
    $provider: String!
    $enabled: Boolean!
    $tenantId: String
    $organisationId: String
    $workspaceId: String
    $counterpartyId: String
  ) {
    setCounterpartySyncScheduleEnabled(
      provider: $provider
      enabled: $enabled
      tenantId: $tenantId
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
    ) {
      schedule {
        provider
        scheduleName
        groupName
        state
        scheduleExpression
        scheduleExpressionTimezone
      }
    }
  }
`;

export const RUN_COUNTERPARTY_SYNC_NOW = /* GraphQL */ `
  mutation RunCounterpartySyncNow(
    $provider: String!
    $tenantId: String
    $organisationId: String
    $workspaceId: String
    $counterpartyId: String
    $intent: String
  ) {
    runCounterpartySyncNow(
      provider: $provider
      tenantId: $tenantId
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
      intent: $intent
    ) {
      success
    }
  }
`;

export const GET_BACKOFFICE_GLOBAL_CONFIG = /* GraphQL */ `
  query GetBackofficeGlobalConfig {
    getBackofficeGlobalConfig {
      settingsTheme {
        themeCustomizerEnabled
      }
      settingsTenancy {
        maxWorkspacesPerOrganisation
        defaultWorkspaceCount
      }
      featureFlags
      fetchedAt
    }
  }
`;

export const LIST_GEO_COUNTRIES = /* GraphQL */ `
  query ListGeoCountries($activeOnly: Boolean) {
    listGeoCountries(activeOnly: $activeOnly) {
      items {
        code
        name
        isActive
      }
    }
  }
`;

export const LIST_INTEGRATIONS = /* GraphQL */ `
  query ListIntegrations($organisationId: String!) {
    listIntegrations(organisationId: $organisationId) {
      integrationKey
      installed
      enabled
      description
      icon
      displayName
      configurationScopes
    }
  }
`;

export const UPDATE_INTEGRATION_CONFIG = /* GraphQL */ `
  mutation UpdateIntegrationConfig(
    $integrationKey: String!
    $installed: Boolean
    $enabled: Boolean
    $organisationId: String
  ) {
    updateIntegrationConfig(
      integrationKey: $integrationKey
      installed: $installed
      enabled: $enabled
      organisationId: $organisationId
    ) {
      success
    }
  }
`;

export const GET_INTEGRATION_CONFIG = /* GraphQL */ `
  query GetIntegrationConfig(
    $integrationKey: String!
    $organisationId: String
    $workspaceId: String
    $counterpartyId: String
  ) {
    getIntegrationConfig(
      integrationKey: $integrationKey
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
    ) {
      hasConfig
      config
      version
      lastModified
    }
  }
`;

export const LIST_PARTY_INTEGRATION_CONNECTION_STATUSES = /* GraphQL */ `
  query ListPartyIntegrationConnectionStatuses(
    $integrationKey: String!
    $organisationId: String!
    $workspaceId: String!
    $counterpartyIds: [String!]!
  ) {
    listPartyIntegrationConnectionStatuses(
      integrationKey: $integrationKey
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyIds: $counterpartyIds
    ) {
      items {
        counterpartyId
        integrationKey
        connectionId
        connectionServerUrl
        instanceSerialNumber
        lastInstanceSerialNumber
        connectionStatus
        connectedAt
        disconnectedAt
        publicId
        counterpartyName
        refdataStatus
        refdataRunId
        refdataSyncedAt
        refdataLastError
        refdataKinds
      }
    }
  }
`;

export const LIST_INTEGRATION_AUDIT_EVENTS = /* GraphQL */ `
  query ListIntegrationAuditEvents(
    $integrationKey: String!
    $organisationId: String!
    $workspaceId: String!
    $counterpartyId: String
    $limit: Int
  ) {
    listIntegrationAuditEvents(
      integrationKey: $integrationKey
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
      limit: $limit
    ) {
      items {
        eventId
        eventType
        createdAt
        actorId
        organisationId
        workspaceId
        counterpartyId
        previousState
        nextState
      }
    }
  }
`;

export const LIST_PARTY_INTEGRATION_REFDATA_SUMMARIES = /* GraphQL */ `
  query ListPartyIntegrationRefdataSummaries(
    $integrationKey: String!
    $organisationId: String!
    $workspaceId: String!
    $counterpartyId: String!
  ) {
    listPartyIntegrationRefdataSummaries(
      integrationKey: $integrationKey
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
    ) {
      aggregate {
        status
        runId
        syncedAt
        lastError
      }
      items {
        kind
        softoneObject
        dependsOn
        status
        kindRunId
        kindSyncedAt
        lastError
        itemPresent
        connectionId
        syncRunId
        schemaVersion
        dataVersion
        sourceHash
        syncedAt
        count
        ttl
      }
    }
  }
`;

export const ESTABLISH_CONNECTION = /* GraphQL */ `
  mutation EstablishConnection(
    $integrationKey: String!
    $config: AWSJSON
    $organisationId: String
    $workspaceId: String
    $counterpartyId: String
  ) {
    establishConnection(
      integrationKey: $integrationKey
      config: $config
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
    ) {
      success
      message
      status
      instanceSerialNumber
      continuationToken
      loginSelections {
        company
        companyName
        branch
        branchName
        module
        moduleName
        refid
        refidName
      }
    }
  }
`;

export const EXECUTE_INTEGRATION_OPERATION = /* GraphQL */ `
  query ExecuteIntegrationOperation(
    $integrationKey: String!
    $operation: String!
    $params: AWSJSON
    $organisationId: String
    $workspaceId: String
    $counterpartyId: String
  ) {
    executeIntegrationOperation(
      integrationKey: $integrationKey
      operation: $operation
      params: $params
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
    )
  }
`;

export const DISCONNECT_INTEGRATION = /* GraphQL */ `
  mutation DisconnectIntegration(
    $integrationKey: String!
    $organisationId: String
    $workspaceId: String
    $counterpartyId: String
  ) {
    disconnectIntegration(
      integrationKey: $integrationKey
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
    ) {
      success
    }
  }
`;

export const RETRY_SOFTONE_PARTY_REFDATA_SYNC = /* GraphQL */ `
  mutation RetrySoftOnePartyRefdataSync(
    $organisationId: String!
    $workspaceId: String!
    $counterpartyId: String!
    $kinds: [String]
  ) {
    retrySoftOnePartyRefdataSync(
      organisationId: $organisationId
      workspaceId: $workspaceId
      counterpartyId: $counterpartyId
      kinds: $kinds
    ) {
      success
    }
  }
`;
